export const getImageUrl = name => `/${__STATIC_DIRECTORY__}/img/${name}`;
